import { useEffect } from 'react';

/**
 * Composant pour injecter des données structurées JSON-LD dans le head
 * Utile pour le GEO (Generative Engine Optimization)
 * 
 * @param {Object} data - Les données structurées au format Schema.org
 * @param {string} id - ID unique pour le script (optionnel, par défaut 'structured-data')
 */
export function StructuredData({ data, id = 'structured-data' }) {
  useEffect(() => {
    if (!data) return;
    
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    script.id = id;
    
    // Supprimer l'ancien script s'il existe
    const existingScript = document.getElementById(id);
    if (existingScript) {
      existingScript.remove();
    }
    
    document.head.appendChild(script);
    
    return () => {
      const scriptToRemove = document.getElementById(id);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [data, id]);
  
  return null;
}

export default StructuredData;
